/**
 * Pure billing display helpers (billing-credits-01). No I/O — unit-tested.
 */
import { SubscriptionInfo } from '../types';

/** Percentage of the allotment used, clamped to 0..100; 0 when no allotment. */
export function usagePercent(
  used: number | null | undefined,
  included: number | null | undefined
): number {
  if (!included || included <= 0) return 0;
  const u = Math.max(0, Math.min(used ?? 0, included));
  return Math.round((u / included) * 100);
}

/**
 * Label for the sidebar credits indicator. Exempt/grandfathered/admin or
 * billing-off (enforced=false) → "Unlimited"; an enforced subscriber →
 * "N credits left"; an enforced user without a plan → "No plan".
 */
export function creditsLabel(sub: SubscriptionInfo | null): string {
  if (!sub) return '—';
  if (!sub.enforced) return 'Unlimited';
  if (sub.remaining == null) return 'No plan';
  return `${sub.remaining.toLocaleString()} left`;
}

/** True when a compact usage widget/bar should render (enforced + has a plan). */
export function showsUsage(sub: SubscriptionInfo | null): boolean {
  return !!sub && sub.enforced && sub.remaining != null && (sub.included_dials ?? 0) > 0;
}
